import { Box, styled } from '@mui/material';
var SectionContainer = styled(Box)(function () {
  return {};
});
var Title = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingBottom: theme.spacing(7.5)
  };
});
var Body = styled(Box)(function () {
  return {};
});
export { Body, SectionContainer, Title };